import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './ButtonLink.css';

export interface IPhoneButtonProps {
  children: React.ReactNode;
  linkStyles?: IStyleConfig;
  onClick(): void;
}

export function ButtonLink({ children, onClick, linkStyles }: IPhoneButtonProps) {
  return (
    <span {...mergeStyles(styles['button_link'], linkStyles)} onClick={onClick}>
      {children}
    </span>
  );
}
